<template>
  <span>{{ data }}</span>
</template>

<script>
export default {
  props: ['data']
}
</script>
